<template>
  <v-navigation-drawer
    :value="menuOpen"
    @input="(newValue) => $store.commit('MainTemplate/setMenuOpen', newValue)"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title class="d-flex justify-center" id="menu.logo">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo.png" class="mb-5" width="100" />
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle class="d-flex justify-center" id="menu.ano_selector">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir && item.children.filter((child) => $can(child.permissions)).length > 0
        )"
        :key="item.title"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title :id="item.id" v-text="item.title" />
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="child in item.children"
          v-show="$can(child.permissions) && (child.exibir === undefined || child.exibir)"
          :key="child.title"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title :id="child.id" v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    menu() {
      return {
        items: [
          {
            icon: "mdi mdi-home",
            title: "Início",
            id: "menu.inicio",
            exibir: true,
            children: [
              {
                title: "Ir para Início",
                id: "menu.ir_para_inicio",
                to:
                  (this.user ? this.user.roleName : "") === "professor"
                    ? {
                        name: "acessoProfessor.home",
                      }
                    : {
                        name:
                          (this.user ? this.user.roleName : "") === "prof-auxiliar"
                            ? "acessoProfessor.home"
                            : "home",
                      },
                icon: "",
              },
              {
                title: "Ir para notifiq",
                id: "menu.ir_para_notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-book-education",
            title: "Agenda",
            id: "menu.agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                title: "Ir para Agendas",
                id: "menu.ir_para_agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-comment-alert",
            title: "Avisos",
            id: "menu.avisos",
            exibir: (this.user ? this.user.roleName : "") !== "professor",
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                title: "Ir para Avisos",
                id: "menu.ir_para_avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-school",
            title: "Matrículas",
            id: "menu.matriculas",
            exibir: true,
            children: [
              {
                title: "Ver Matrículas",
                id: "menu.ver_matriculas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              {
                title: "Ver Alunos",
                id: "menu.ver_alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                title: "Pesquisa avançada",
                id: "menu.pesquisa_avancada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-school",
            title: "Turmas",
            id: "menu.turmas",
            exibir: true,
            children: [
              {
                title: "Ver turmas",
                id: "menu.ver_turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                title: "Gestão de anos",
                id: "menu.gestao_anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                title: "Gestão de disciplinas",
                id: "menu.gestao_disciplinas",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            icon: "mdi mdi-note-text",
            title: "Planos",
            id: "menu.planos",
            exibir:
              this.user &&
              !["professor", "assistente-social", "psicologo(a)"].includes(this.user.roleName),
            children: [
              {
                title: "Listar planos semestrais",
                id: "menu.listar_planos",
                to: { name: "gestoesDeAulas.planos" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Listar planos bimestrais",
                id: "menu.listar_planos",
                to: { name: "gestoesDeAulas.planosBimestrais" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Listar planos infantis bimestrais",
                id: "menu.listar_planos_infantis",
                to: { name: "gestoesDeAulas.planosInfantilBimestrais" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Listar planos infantis semestres",
                id: "menu.listar_planos_infantis",
                to: { name: "gestoesDeAulas.planosInfantil" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
            ],
          },
          {
            icon: "mdi-human-male-board-poll",
            title: "Diário online",
            id: "menu.diario_online",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                id: "menu.diario_online.listar_todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Gestão geral",
                id: "menu.diario_online.gestao_geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
                exibir: ![
                  "secretario",
                  "direção",
                  "coordenador",
                  "psicologo(a)",
                  "assistente-social",
                ].includes(this.user?.roleName),
              },
              {
                title: "Agendas",
                id: "menu.diario_online.agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
                exibir:
                  (this.user ? this.user.roleName : "") !== "psicologo(a)" &&
                  (this.user ? this.user.roleName : "") !== "assistente-social",
              },
            ],
          },
          {
            icon: "query_stats",
            title: "Desempenho Pedagógico",
            id: "menu.desempenho_pedagogico",
            exibir: true,
            children: [
              {
                title: "Desempenho Professor",
                id: "menu.desempenho_pedagogico.professor",
                to: { name: "usabilidade.usabilidadeDoSistemaProfessor" },
                icon: "",
                permissions: ["desempenhoPedagogico.desempenhoProfessor", "desempenhoPedagogico.*"],
              },
              {
                title: "Desempenho Coordenador",
                id: "menu.desempenho_pedagogico.coordenador",
                to: { name: "usabilidade.usabilidadeDoSistemaCoordenador" },
                icon: "",
                permissions: [
                  "desempenhoPedagogico.desempenhoCoordenador",
                  "desempenhoPedagogico.*",
                ],
              },
            ],
          },
          // {
          //   icon: "mdi-human-male-board",
          //   title: "Diário de Auxiliares",
          //   id: "menu.diario_auxiliares",
          //   exibir: true,
          //   children: [
          //     {
          //       title: "Listar todos",
          //       id: "menu.diario_auxiliares.listar_todos",
          //       to: { name: "gestoesDeAulasAuxiliares" },
          //       icon: "",
          //       permissions: [
          //         "gestoesDeAulasAuxiliares.*",
          //         "gestoesDeAulasAuxiliares.criar",
          //         "gestoesDeAulasAuxiliares.listar",
          //       ],
          //     },
          //   ],
          // },
          {
            icon: "mdi mdi-chart-box",
            title: "Relatórios",
            id: "menu.relatorios",
            exibir: true,
            children: [
              {
                title: "Ver todos",
                id: "menu.ver_todos_relatorios",
                to: {
                  name: `relatorios`,
                  params: { franquiaId: this.user.franquia.id },
                },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            icon: "mdi mdi-account-switch",
            title: "Usuários",
            id: "menu.usuarios",
            exibir: true,
            children: [
              {
                title: "Ver Professores",
                id: "menu.ver_professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                title: "Profissionais de Apoio",
                id: "menu.profissionais_apoio",
                to: { name: "profissionaisDeApoio" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                title: "Bloqueios/Liberações",
                id: "menu.bloqueios_liberacoes",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
              {
                title: "Outros",
                id: "menu.outros_usuarios",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            icon: "mdi mdi-cash-multiple",
            title: "Financeiro",
            id: "menu.financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                title: "Mensalidades",
                id: "menu.mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                title: "Gestão de Caixas",
                id: "menu.gestao_caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-network",
            title: "Administração",
            id: "menu.administracao",
            permissions: ["franquias.*"],
            exibir: true,
            children: [
              // {
              //   title: "Dashboard",
              //   to: { name: "admin" },
              //   permissions: ["franquias.*", "franquias.criarFranquia"],
              //   icon: "",
              // },
              {
                title: "Franquias",
                id: "menu.franquias",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Circuito De Notas",
                id: "menu.circuito_notas",
                to: { name: "circuito-notas" },
                permissions: ["circuitoNotas.*"],
                icon: "",
              },
              {
                title: "Solitações de Deleções",
                id: "menu.solitacoes_delecao",
                to: { name: "solicitacoes-delecao" },
                permissions: ["franquias.*"],
                icon: "",
              },
              {
                title: "Bolsa Família",
                to: { name: "bolsa-familia" },
                permissions: ["bolsaFamilia.*"],
                icon: "",
              },
              {
                title: "Calculadora FUNDEB",
                to: { name: "fundeb.calculadora" },
                permissions: ["franquias.*"],
                exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-calendar-check",
            title: "Calendário Letivo",
            exibir: !["coordenador", "professor", "assistente-social", "psicologo(a)"].includes(
              this.user?.roleName
            ),
            children: [
              {
                title: "Calendário",
                to: { name: "calendario-letivo.create" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Adicionar Categoria",
                to: { name: "eventos-calendario-letivo" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-help",
            title: "Ajuda e tutorial",
            id: "menu.ajuda_tutorial",
            exibir: true,
            children: [
              {
                title: "Tutoriais",
                id: "menu.tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
  },
};
</script>
